import { projectConfig } from '@U/projectConfig'

const link = document.createElement('link')
link.setAttribute('rel', 'icon')
link.setAttribute('href', projectConfig.faviconUrl)
document.getElementsByTagName('head')[0].appendChild(link)
